
import React from 'react';
import { Facebook, Instagram, Youtube, Mail, Phone } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-rustico-brown text-white py-12 px-6 mt-10">
      <div className="container mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
        {/* Logo and Description */}
        <div>
          <img src="/logo.png" alt="RusticoPlay Logo" className="h-16 mb-4" />
          <p className="text-sm text-white/80">
            RusticoPlay: Seu destino para música sertaneja, shows ao vivo e conteúdo exclusivo de Zezé Di Camargo & Amigos Sertanejos.
          </p>
        </div>

        {/* Quick Links */}
        <div>
          <h3 className="text-xl font-bold mb-4">Navegação</h3>
          <ul className="space-y-2">
            <li><Link to="/" className="hover:text-white/70 transition-colors">Início</Link></li>
            <li><Link to="/shows" className="hover:text-white/70 transition-colors">Shows</Link></li>
            <li><Link to="/filmes" className="hover:text-white/70 transition-colors">Filmes</Link></li>
            <li><Link to="/series" className="hover:text-white/70 transition-colors">Séries</Link></li>
            <li><Link to="/minha-lista" className="hover:text-white/70 transition-colors">Minha Lista</Link></li>
          </ul>
        </div>

        {/* Contact and Social */}
        <div>
          <h3 className="text-xl font-bold mb-4">Contato</h3>
          <div className="space-y-3">
            <div className="flex items-center space-x-2">
              <Mail size={20} />
              <span>contato@rusticoplay.com</span>
            </div>
            <div className="flex items-center space-x-2">
              <Phone size={20} />
              <span>(11) 99999-9999</span>
            </div>
            <div className="flex space-x-4 mt-4">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="hover:text-white/70 transition-colors">
                <Facebook size={24} />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="hover:text-white/70 transition-colors">
                <Instagram size={24} />
              </a>
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="hover:text-white/70 transition-colors">
                <Youtube size={24} />
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="text-center mt-8 pt-6 border-t border-white/20">
        <p className="text-sm text-white/60">
          © {new Date().getFullYear()} RusticoPlay. Todos os direitos reservados.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
